import { createStyles } from '@mui/styles';
import { APTheme } from "../../../../core/TenantProvider/tenants";

export default (theme: APTheme) =>
  createStyles({
    iconSurround: {
      display: "flex",
      width: "100%",
      justifyContent: "center",
      marginTop: 30,
    },
  });
